import React from 'react';
import LegalDocumentViewer from '../legal-document/LegalDocumentViewer';
import CustomCard from '../../components/CustomCard';

const PublicActualLegalDocumentPage = () => {

  return (
    <LegalDocumentViewer card={CustomCard} isPublic={true} />

  );
};

export default PublicActualLegalDocumentPage;
